import { useMutation } from '@apollo/client';
import { useContext } from 'react';
import { AuthContext } from 'routes/auth.context';
import { GRAPHQL_EXCLUIR_TAXA } from '../../../../gql/taxas';

export const useDeleteTaxa = (props) => {
    const { alertConfirm } = useContext(AuthContext);

    const [excluirTaxaMutation, { loading }] = useMutation(GRAPHQL_EXCLUIR_TAXA, {
        onCompleted: () => {
            alertConfirm({
                tipo: 'sucesso',
                titulo: 'Sucesso',
                conteudo: 'Taxa excluída com sucesso!',
            });
            props?.refetch?.();
        },
        onError: (error) => {
            alertConfirm({
                tipo: 'erro',
                titulo: 'Erro',
                conteudo: error.message || 'Erro ao excluir taxa',
            });
        },
    });

    const handleDeleteTaxa = async (taxa) => {
        const confirm = window.confirm(
            'Tem certeza que deseja excluir esta taxa?'
        );

        if (confirm) {
            await excluirTaxaMutation({
                variables: {
                    id: taxa.id,
                },
            });
        }
    };

    return {
        handleDeleteTaxa,
        loading,
    };
};